/**
 * Centralized field labels enum
 * Maintains consistent labeling across the entire application
 * (Tables, Forms, Filters, Reports, etc.)
 */

export enum FieldLabels {
  // Patient Information
  PATIENT_ID = 'Patient ID',
  PATIENT_NAME = 'Patient Name',
  PATIENT_AGE = 'Patient Age',
  PATIENT_SEX = 'Patient Sex',
  PATIENT_GENDER = 'Patient Gender',
  PATIENT_DOB = 'Patient Birth Date',
  MRN = 'MRN',

  // Patient Information (Short Forms - for tables)
  PATIENT_ID_SHORT = 'Pat. ID',
  PATIENT_AGE_SHORT = 'Pat. Age',
  PATIENT_SEX_SHORT = 'Pat. Sex',

  PATIENT_REPORT_AGE = 'Age',
  PATIENT_REPORT_SEX = 'Sex',

  // Study Information
  MODALITY = 'Modality',
  BODY_PART = 'Body Part',
  STUDY_DESCRIPTION = 'Study Description',
  STUDY_DESCRIPTION_SHORT = 'Study Desc.',
  STUDY_DATE = 'Study Date',
  SCAN_DATE = 'Scan Date',
  RECEIVED_DATE = 'Received Date',
  SITE = 'Site',
  HISTORY = 'History',
  ITEM_CODE = 'Item Code',
  SERIES_COUNT = 'Ser/images ',

  // Order Information
  ORDER_NUMBER = 'Order No',
  ACCESSION_NUMBER = 'Accession Number',
  ACCESSION_NUMBER_SHORT = 'Acc. No',
  ACCESSION_NUMBER_SHORTEST = 'Acc No',
  REFERRING_DOCTOR = 'Ref Doc',
  REFERRING_PHYSICIAN = 'Referring Physician',

  // Status & Assignment
  STATUS = 'Status',
  ASSIGNED_TO = 'Assigned To',
  ASSIGNED_RADIOLOGIST = 'Assigned to',
  TECHNICIAN = 'Technician',
  REPORTED_BY = 'Reported by',
  SIGNED_BY = 'Signed by',

  // Technical Details
  AE_TITLE = 'AE Title',
  INSTANCES = 'Instances',
  SERIES = 'Series',
  DESCRIPTION = 'Description',

  // Actions
  ACTIONS = 'Actions',
}

/**
 * Permissions enum
 * Maintains consistent permission keys across the application
 */
export enum Permissions {
  CREATE_TECH_NOTES = 'CREATE_TECH_NOTES',
  ASSIGN_CASES = 'ASSIGN_CASES',
  MODIFY_STUDY_DETAILS = 'MODIFY_STUDY_DETAILS',
  UPLOAD_DICOM = 'UPLOAD_DICOM',
}
